import { render, staticRenderFns } from "./ServiceHeader.vue?vue&type=template&id=98fb2148&scoped=true"
import script from "./ServiceHeader.vue?vue&type=script&lang=js"
export * from "./ServiceHeader.vue?vue&type=script&lang=js"
import style0 from "./ServiceHeader.vue?vue&type=style&index=0&id=98fb2148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fb2148",
  null
  
)

export default component.exports